const API = (base, fn) => {
    return (
        "https://gycback.herokuapp.com/"+base+"/"+fn
    )
}

export default API
